// import React, { useEffect, useState } from 'react';
// import { Stack, Box, Typography } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import useResponsive from '../../hooks/useResponsive';
// import { useLocation, useNavigate } from 'react-router-dom';
// import Header from '../../layout/dashboard/header';
// import MedicDetailsContent from '../../components/medic/MedicDetailsContent';
// import { getUrlPathId } from '../../utils/url-id';
// import { useAuth } from '../../hooks/useAuth';
// import { useMutation } from '@tanstack/react-query';
// import { apiGetMedicById } from '../../api/medic';
// import { useNotificationService } from '../../components/notification';
// import {
//   MedicInfoDummyText,
//   MedicInfoProps,
//   MedicInformationDummyData,
//   MedicInformationProps,
// } from '../../interface/medic';
// import BackButton from '../../components/UIElements/BackButton';

// const MedicDetails = () => {
//   const theme = useTheme();
//   const isMedium = useResponsive('down', 'md', 'xl');
//   const isSmall = useResponsive('down', 'sm', 'xl');
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { token } = useAuth();
//   const { showNotification } = useNotificationService();
//   const [medic_data, seetMedic_data] = useState<MedicInformationProps>(
//     MedicInformationDummyData
//   );
//   const [refresh, setRefresh] = useState(false);
//   const handleRefresh = () => setRefresh(!refresh);
//   useEffect(() => {
//     const medicId = getUrlPathId(location?.pathname);
//     const fields = { medicId: medicId, token: token };
//     mutation.mutate(fields);
//   }, [refresh]);

//   const mutation = useMutation({
//     mutationFn: (fields: { medicId: string; token: string }) =>
//       apiGetMedicById(fields),
//     onSuccess: (data) => {
//       if (data?.status === 'error') {
//         if ('msg' in data) {
//           showNotification(data?.msg ?? '', 'error');
//           return;
//         }
//         return;
//       }
//       if ('data' in data) {
//         seetMedic_data(data.data.data);
//       }
//     },
//     onError: (error) => {
//       showNotification('Fetch process failed', 'error');
//     },
//   });

//   return (
//     <>
//       {/* Header Menu */}
//       <Header>
//         <Box
//           sx={{
//             flexGrow: 1,
//             display: 'flex',
//             flexDirection: 'row',
//             gap: '10px',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             marginRight: '1rem',
//             height: isMedium ? 60 : 75,
//           }}
//         >
//           <Stack direction={'row'} alignItems={'center'} sx={{ gap: '10px' }}>
//             <BackButton />
//             <Typography
//               variant={'subtitle1'}
//               sx={{
//                 fontWeight: 500,
//                 fontFamily: 'Lexend',
//                 color: theme.palette.secondary.dark,
//               }}
//             >
//               Personnel Management
//             </Typography>
//           </Stack>
//         </Box>
//       </Header>
//       <MedicDetailsContent
//         medicInfo={medic_data}
//         loading={mutation.isPending}
//         handleRefresh={handleRefresh}
//       />
//     </>
//   );
// };

// export default MedicDetails;

import React, { useEffect, useMemo, useState } from "react";
import { Stack, Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../layout/dashboard/header";
import MedicDetailsContent from "../../components/medic/MedicDetailsContent";
import { getUrlPathId } from "../../utils/url-id";
import { useQuery } from "@tanstack/react-query";
import { apiGetMedicById } from "../../api/medic";
import { useNotificationService } from "../../components/notification";
import {
  MedicInformationDummyData,
  MedicInformationProps,
} from "../../interface/medic";
import BackButton from "../../components/UIElements/BackButton";

const MedicDetails = () => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");

  const location = useLocation();
  const { showNotification } = useNotificationService();

  const [refreshIndex, setRefreshIndex] = useState(0);
  const medicId = useMemo(() => getUrlPathId(location?.pathname), [location]);

  const handleRefresh = () => setRefreshIndex((prev) => prev + 1);

  const { data, isPending } = useQuery({
    queryKey: ["medic-details", medicId, refreshIndex],
    queryFn: () => apiGetMedicById({ medicId }),
    enabled: !!medicId,
    staleTime: 1000 * 60 * 5, // 5 minutes

    select: (data) => {
      if (data?.status === "error" && "msg" in data) {
        showNotification(data?.msg ?? "", "error");
        return {};
      }
      return data?.data ?? {};
    },
  });

  const medic_data: MedicInformationProps =
    data?.data ?? MedicInformationDummyData;
  console.log(medic_data, "TT");
  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <BackButton />
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: theme.palette.secondary.dark,
              }}
            >
              Personnel Management
            </Typography>
          </Stack>
        </Box>
      </Header>

      <MedicDetailsContent
        medicInfo={medic_data}
        loading={isPending}
        handleRefresh={handleRefresh}
      />
    </>
  );
};

export default MedicDetails;
